import React from "react";
import { Modal } from "antd";
import type { ModalProps } from "antd";
import clsx from "clsx";
import modalStyles from "@/asserts/styles/commonModal.module.less";

/**
 * 将 Modal 包装为带默认 className 的组件。
 * - 默认 className: 'commonModal'
 * - 会合并用户传入的 className（用户 className 在后面以覆盖默认）
 * - 支持 ref 转发（ref 指向 Modal 组件实例）
 */
function withCommonModal<T extends ModalProps = ModalProps>(
  WrappedModal = Modal,
) {
  type Props = T;

  const CommonModal = React.forwardRef<any, Props>((props, ref) => {
    const { className, ...rest } = props as Props;

    return (
      <WrappedModal
        ref={ref}
        className={clsx([modalStyles.commonModal, className])}
        {...(rest as Props)}
        destroyOnHidden
      />
    );
  });

  return CommonModal;
}

// 导出默认的 CommonModal（直接包装 AntD 的 Modal）
export const CommonModal = withCommonModal(Modal);
export default CommonModal;
